import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container, Row, Table, Form } from "react-bootstrap";
import "../../../assets/styles/dashboard.scss";
import { useApiPost } from "../../../hooks/useApiPost";
import { useSort } from "../../../hooks/useSort";

const RecordsTerminalEX = () => {
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const { submit, isSubmitting, error } = useApiPost("/Terminal/Records");
  const { sortConfig, sortedData, requestSort } = useSort(records);
  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      const response = await submit({
        type: "EX",
        code: searchTerm,
      });
      setRecords(Array.isArray(response) ? response : []);
    } catch (err) {
      console.error("Error fetching terminal records:", err);
      setRecords([]);
    }
  };

  return (
    <div className="routes-list-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <h4>Rekordy EX na terminal</h4>
        </Row>
        <Row className="mb-4">
          <Form className="d-flex w-100" onSubmit={handleSearch}>
            <Form.Control
              type="text"
              placeholder="Szukaj"
              className="me-2 flex-grow-1"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button
              variant="primary"
              className="dashboard-only-button"
              type="submit"
              disabled={isSubmitting}
            >
              Szukaj
            </Button>
          </Form>
        </Row>
        {isSubmitting && (
          <Row className="mb-3">
            <div className="d-flex align-items-center">
              <div
                className="spinner-border text-primary"
                role="status"
                aria-hidden="true"
              />
              <span className="ms-2">Wyszukiwanie...</span>
            </div>
          </Row>
        )}
        {error && (
          <Row>
            <div className="alert alert-danger" role="alert">
              Błąd podczas pobierania danych: {error.message || "Nieznany błąd"}
            </div>
          </Row>
        )}
        {records.length > 0 && (
          <Row>
            <div className="table-scroll-7 w-100">
              <Table
                responsive
                striped
                bordered
                hover
                size="sm"
                className="custom-table"
              >
                <thead>
                  <tr>
                    <th
                      onClick={() => requestSort("code")}
                      style={{ cursor: "pointer" }}
                    >
                      EX
                      {sortConfig.key === "code" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                    <th
                      onClick={() => requestSort("count")}
                      style={{ cursor: "pointer" }}
                    >
                      Ilość
                      {sortConfig.key === "count" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((record, index) => (
                    <tr key={index}>
                      <td>{record.code}</td>
                      <td>{record.count}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Row>
        )}
      </Container>
    </div>
  );
};
export default RecordsTerminalEX;
